/*
  The course intake has no upload. The preview seals the course, name, time and
  variant; the cart receives only that seal, the course and the pending-time flag.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-race-course]');
  if (!root) return;

  /* Plan 72 T2. Copied, not shared: this page does not load `traceform-preview.js`.
     `e2e/instrumentation.spec.ts` keeps the two copies identical. */
  function browserKind() {
    var ua = (window.navigator && window.navigator.userAgent) || '';
    if (/FBAN|FBAV|Instagram/.test(ua)) return 'iab';
    if (/Safari/.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|EdgiOS|EdgA|OPiOS|Android/.test(ua)) return 'safari';
    return 'other';
  }

  function $(selector) { return root.querySelector(selector); }
  function testid(id) { return $('[data-testid="' + id + '"]'); }

  var form = $('[data-course-form]');
  var cards = root.querySelectorAll('[data-course][data-race-date]');
  var nameInput = testid('course-name');
  var timeInput = testid('finish-time');
  var modes = $('[data-time-modes]');
  var timeTemplate = $('[data-time-template]');
  var previewButton = testid('course-preview-button');
  var previewLabel = previewButton.textContent;
  var previewImage = testid('course-preview');
  var previewPanel = $('[data-preview-panel]');
  var addButton = testid('course-add-to-cart');
  var dockButton = testid('course-dock-buy');
  var addLabel = addButton.textContent.trim();
  var addNameHint = $('[data-add-name-hint]');
  var timeError = testid('error-finish-time');
  var previewError = $('[data-preview-error]');
  var storyError = $('[data-story-error]');
  var course = null;
  var ahead = false;
  var requestId = 0;
  var seal = null;
  var imageUrl = null;
  var hasPreview = false;
  var cartBusy = false;
  var frozenInputs = [];
  var restoreError = $('[data-restore-error]');
  var storageKey = 'traceform:course-preview:v1';
  var savedPreview = null;
  var returningPreview = Boolean(history.state && history.state.traceformCoursePreview);
  var savingPreview = Promise.resolve();
  try { savedPreview = JSON.parse(sessionStorage.getItem(storageKey)); } catch (err) { /* storage is optional */ }

  function audience() { return $('input[name="race-course-audience"]:checked').value; }
  function syncAudience() {
    root.querySelectorAll('[data-audience-copy]').forEach(function (node) {
      node.textContent = node.getAttribute('data-' + audience());
    });
  }

  function keepPreview(blob, snapshot, story, finish) {
    savingPreview = new Promise(function (resolve) {
      var reader = new FileReader();
      reader.onload = function () {
        if (seal === snapshot) {
          try {
            sessionStorage.setItem(storageKey, JSON.stringify({
              seal: snapshot, image: reader.result, name: story, time: finish, audience: audience(), renderedAt: snapshot.renderedAt
            }));
          } catch (err) { /* a private/full store must not prevent checkout */ }
        }
        resolve();
      };
      reader.onerror = resolve;
      reader.readAsDataURL(blob);
    });
  }

  function unlockCart() {
    cartBusy = false;
    frozenInputs.forEach(function (node) { node.disabled = false; });
    frozenInputs = [];
    addButton.disabled = !seal;
    addButton.removeAttribute('aria-busy');
    syncDock();
  }
  // Plan 82 P2: "send it to whoever's buying", shown only under a sealed preview.
  var hintNode = $('[data-hint]');
  var hint = hintNode && window.TraceformHint
    ? window.TraceformHint.mount(hintNode, function () { clarityEvent('hint_sent'); })
    : null;

  /* Plan 77 F2: a race is sold until race day + 28, the window its ads run in
     (`research/race-calendar-2026.md`). Past that the card goes, so "Pick the race"
     never offers a race nobody is still buying for. */
  var SELL_DAYS_AFTER = 28;

  function daysFromRace(card) {
    var parts = card.getAttribute('data-race-date').split('-');
    var today = new Date();
    var localDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    var raceDay = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    return Math.round((localDay.getTime() - raceDay.getTime()) / 86400000);
  }

  function raceAhead(card) { return daysFromRace(card) <= 0; }

  function onSale(card) { return daysFromRace(card) <= SELL_DAYS_AFTER; }

  function clarityEvent(name) {
    if (typeof window.clarity !== 'function') return;
    try { window.clarity('event', name); } catch (err) { /* telemetry must never break the page */ }
  }

  function timeMode() {
    var selected = $('input[name="race-course-time-mode"]:checked');
    return ahead && selected ? selected.value : 'none';
  }

  function variant() { return $('input[name="race-course-variant"]:checked'); }

  function syncDock() {
    var selected = variant();
    previewPanel.setAttribute('data-variant', selected ? selected.value : '');
    var price = selected && selected.closest('.variant-card').querySelector('.variant-price');
    var copyBox = testid('copy-addon');
    var label = price ? price.textContent.trim() : '';
    // The button names what the cart will hold: a checked second print is in the total.
    if (selected && copyBox && copyBox.checked) {
      var cents = Number(selected.getAttribute('data-price')) + Number(copyBox.getAttribute('data-copy-price'));
      label = '$' + (cents % 100 ? (cents / 100).toFixed(2) : String(cents / 100));
    }
    dockButton.textContent = addLabel + (label ? ' \u2013 ' + label : '');
    addButton.textContent = dockButton.textContent;
    // Like the PDP, keep the dock in place during a redraw, but lock stale seals.
    dockButton.hidden = !hasPreview;
    dockButton.disabled = !seal || cartBusy;
    if (cartBusy) dockButton.setAttribute('aria-busy', 'true');
    else dockButton.removeAttribute('aria-busy');
  }

  function syncTime() {
    var later = timeMode() === 'later';
    $('[data-time-field]').hidden = later;
    timeInput.disabled = later;
    timeInput.required = ahead && !later;
    $('[data-later-helper]').hidden = !later;
    $('[data-delivery-now]').hidden = later;
    $('[data-delivery-later]').hidden = !later;
    root.querySelectorAll('[data-time-known]').forEach(function (node) { node.hidden = !ahead; });
    root.querySelectorAll('[data-time-passed]').forEach(function (node) { node.hidden = ahead; });
  }

  function setDrawing(on) {
    previewButton.disabled = on;
    previewButton.textContent = on ? previewButton.getAttribute('data-busy-label') : previewLabel;
    if (on) previewButton.setAttribute('aria-busy', 'true');
    else previewButton.removeAttribute('aria-busy');
  }

  // Wait until page restoration and image layout have settled; never smooth-scroll.
  var restoredPreviewRevealed = false;
  function revealRestoredPreview() {
    if (restoredPreviewRevealed) return;
    restoredPreviewRevealed = true;
    function reveal() {
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        var rect = previewPanel.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) {
          previewPanel.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      }); });
    }
    if (document.readyState === 'complete') reveal();
    else window.addEventListener('pageshow', reveal, { once: true });
  }

  function showPreview() {
    // On a phone the sheet starts below the fold; bring it up. Beside the form
    // (desktop, sticky) it is already in view and the page stays put.
    var top = previewPanel.getBoundingClientRect().top;
    if (top >= 0 && top < window.innerHeight * 0.5) return;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    previewPanel.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
  }

  function clearErrors() {
    timeError.hidden = true;
    previewError.hidden = true;
    storyError.hidden = true;
    timeInput.removeAttribute('aria-invalid');
  }

  function invalidate(keepLayout) {
    $('[data-preview-update]').hidden = !hasPreview;
    try { sessionStorage.removeItem(storageKey); } catch (err) { /* storage is optional */ }
    try { history.replaceState(Object.assign({}, history.state, { traceformCoursePreview: false }), ''); } catch (err) { /* optional */ }
    previewImage.onload = null;
    previewImage.onerror = null;
    restoreError.hidden = true;
    // A seal drawn without a time, then given one, would otherwise reach the cart
    // without _time_pending: it would print without the time and email nobody.
    requestId += 1;
    seal = null;
    syncDock();
    addButton.disabled = true;
    // Keep the old sheet in layout while a format redraw is pending.
    if (keepLayout !== true) previewPanel.hidden = true;
    setDrawing(false);
    if (imageUrl) URL.revokeObjectURL(imageUrl);
    imageUrl = null;
    if (keepLayout !== true) previewImage.removeAttribute('src');
    clearErrors();
  }

  function chooseCourse(card) {
    invalidate();
    course = card;
    root.querySelectorAll('[data-course-example]').forEach(function (example) {
      example.hidden = example.getAttribute('data-course-example') !== card.getAttribute('data-course');
      if (!example.hidden) {
        var image = example.querySelector('img');
        image.loading = 'eager';
        image.setAttribute('fetchpriority', 'high');
      }
    });
    ahead = raceAhead(card);
    modes.textContent = '';
    if (ahead) modes.appendChild(timeTemplate.content.cloneNode(true));
    $('[data-selected-date]').value = card.querySelector('[data-course-date]').textContent;
    syncTime();
  }

  function validTime(value) {
    if (!/^\d{1,2}:\d{2}:\d{2}$/.test(value)) return false;
    var parts = value.split(':').map(Number);
    return parts[0] < 24 && parts[1] < 60 && parts[2] < 60 &&
      parts[0] * 3600 + parts[1] * 60 + parts[2] > 0;
  }

  function draw(keepPosition) {
    if (cartBusy) return;
    invalidate(keepPosition);
    if (!course) return;
    // A tab can stay open across race day. Recheck the local date before sealing.
    if (ahead !== raceAhead(course)) chooseCourse(course);
    var selected = variant();
    var mode = timeMode();
    var story = nameInput.value.trim();
    var finish = mode === 'later' ? '' : timeInput.value;
    if ((mode === 'known' || finish !== '') && !validTime(finish)) {
      timeError.hidden = false;
      timeInput.setAttribute('aria-invalid', 'true');
    }
    if (!timeError.hidden) {
      timeInput.focus();
      return;
    }
    if (!selected || selected.disabled || !selected.getAttribute('data-variant-id')) return;

    var snapshot = {
      course: course.getAttribute('data-course'),
      mode: mode,
      variant: selected.value,
      id: Number(selected.getAttribute('data-variant-id'))
    };
    var body = new FormData();
    body.append('course', snapshot.course);
    body.append('story', story);
    body.append('finish_time', finish);
    body.append('variant', selected.getAttribute('data-sku'));
    body.append('units', 'mi');
    body.append('style', 'paper-ink');
    body.append('tribe', 'running');
    var currentRequest = requestId;
    setDrawing(true);

    var previewUrl = root.getAttribute('data-preview-url');
    if (window.tfInternalUrl) previewUrl = window.tfInternalUrl(previewUrl);
    fetch(previewUrl, { method: 'POST', body: body })
      .then(function (response) {
        if (currentRequest !== requestId) return null;
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (error) {
            throw new Error(typeof error.detail === 'string' && error.detail.indexOf('story rejected') === 0 ? 'story' : 'preview');
          });
        }
        var token = response.headers.get('x-traceform-entitlement');
        if (!token || !token.trim()) throw new Error('preview');
        return response.blob().then(function (blob) {
          if (currentRequest !== requestId) return;
          if (blob.type.split(';')[0] !== 'image/png') throw new Error('preview');
          imageUrl = URL.createObjectURL(blob);
          previewImage.src = imageUrl;
          addNameHint.hidden = story !== '';
          previewPanel.hidden = false;
          if (keepPosition !== true) showPreview();
          $('[data-preview-update]').hidden = true;
          snapshot.token = token;
          snapshot.renderedAt = Date.now();
          seal = snapshot;
          keepPreview(blob, snapshot, story, finish);
          hasPreview = true;
          if (hint) hint.show({ course: snapshot.course, name: story, time: finish, format: snapshot.variant });
          addButton.disabled = cartBusy;
          syncDock();
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            // A pixel failure must not turn a drawable, sealed print into an error.
            try {
              window.Shopify.analytics.publish('traceform_course_preview', {
                source: 'course', course: snapshot.course, time_mode: snapshot.mode, variant: snapshot.variant, browser: browserKind()
              });
            } catch (err) { /* The preview and its seal are already complete. */ }
          }
          // Plan 77 F5: the PDP's step names, so one Clarity funnel spans both doors.
          clarityEvent('preview_ok');
        });
      })
      .catch(function (err) {
        if (currentRequest !== requestId) return;
        clarityEvent('preview_failed');
        (err.message === 'story' ? storyError : previewError).hidden = false;
      })
      .then(function () {
        if (currentRequest !== requestId) return;
        setDrawing(false);
      });
  }

  // Plan 75: an ad for one race lands on that race, under the ad's own headline.
  // Only entries with a course are this page's; any other id leaves it as it is.
  var landing = window.TraceformLanding
    ? window.TraceformLanding.landingFor(new URLSearchParams(window.location.search).get('tf_creative'))
    : {};
  var onSaleCards = Array.prototype.filter.call(cards, onSale);
  cards.forEach(function (card) {
    if (onSale(card)) return;
    card.hidden = true;
    card.querySelector('input').checked = false;
  });
  if (landing.course) {
    var landed = root.querySelector('input[name="race-course"][value="' + landing.course + '"]');
    // An ad whose race has left its window lands on the page as it is, not on a
    // race that can no longer be picked.
    if (landed && onSale(landed.closest('[data-course]'))) {
      landed.checked = true;
      var landingCopy = JSON.parse($('[data-landing-copy]').textContent);
      if (landingCopy[landing.headline]) $('h1').textContent = landingCopy[landing.headline];
    }
  }
  // Plan 82 P2: a link sent from under a preview opens that race, name, time and
  // format and draws it again. A race no longer on sale opens the page as it is.
  var shared = window.TraceformHint ? window.TraceformHint.read(window.location.search) : null;
  var sharedCard = shared ? onSaleCards.filter(function (card) {
    return card.getAttribute('data-course') === shared.course;
  })[0] : null;
  if (sharedCard) sharedCard.querySelector('input').checked = true;
  if (onSaleCards.length && !onSaleCards.some(function (card) { return card.querySelector('input').checked; })) {
    onSaleCards[0].querySelector('input').checked = true;
  }

  cards.forEach(function (card) {
    var isAhead = raceAhead(card);
    card.querySelector('[data-badge-ahead]').hidden = !isAhead;
    card.querySelector('[data-badge-passed]').hidden = isAhead;
    card.querySelector('input').addEventListener('change', function () {
      chooseCourse(card);
      $('h1').textContent = card.getAttribute('data-headline');
      clarityEvent('race_picked');
    });
    if (card.querySelector('input').checked) chooseCourse(card);
  });

  var initialAudience = new URLSearchParams(window.location.search).get('tf_audience');
  if (initialAudience !== 'gift' && initialAudience !== 'self') {
    initialAudience = /^RG[1-6]$/.test(landing.concept || '') ? 'gift' : 'self';
  }
  $('input[name="race-course-audience"][value="' + initialAudience + '"]').checked = true;
  syncAudience();
  root.querySelectorAll('input[name="race-course-audience"]').forEach(function (input) {
    input.addEventListener('change', syncAudience);
  });

  if (!savedPreview && returningPreview && !sharedCard) restoreError.hidden = false;
  if (savedPreview && returningPreview && !sharedCard) {
    (async function () {
      try {
        var saved = savedPreview.seal;
        var savedCard = onSaleCards.filter(function (card) { return card.getAttribute('data-course') === saved.course; })[0];
        var savedVariant = Array.prototype.find.call(root.querySelectorAll('input[name="race-course-variant"]'), function (input) {
          return input.value === saved.variant && Number(input.getAttribute('data-variant-id')) === saved.id && !input.disabled;
        });
        if (!savedCard || !savedVariant || !saved.token || !/^data:image\/png;base64,/.test(savedPreview.image) ||
            !savedPreview.renderedAt || Date.now() - savedPreview.renderedAt >= 24 * 60 * 60 * 1000) throw new Error('restore');
        var restoringRequest = requestId;
        if (!await window.TraceformBuy.hasEntitlement(saved.token)) {
          sessionStorage.removeItem(storageKey);
          return;
        }
        if (requestId !== restoringRequest) return;
        savedCard.querySelector('input').checked = true;
        chooseCourse(savedCard);
        savedVariant.checked = true;
        nameInput.value = savedPreview.name;
        timeInput.value = savedPreview.time;
        var savedMode = $('input[name="race-course-time-mode"][value="' + (saved.mode === 'known' ? 'known' : 'later') + '"]');
        if (savedMode) savedMode.checked = true;
        $('input[name="race-course-audience"][value="' + (savedPreview.audience === 'gift' ? 'gift' : 'self') + '"]').checked = true;
        syncAudience();
        syncTime();
        previewImage.onload = function () {
          previewImage.onload = null;
          try { history.replaceState(Object.assign({}, history.state, { traceformCoursePreview: true }), ""); } catch (err) { /* optional */ }
          seal = saved;
          hasPreview = true;
          if (hint) hint.show({ course: saved.course, name: savedPreview.name, time: savedPreview.time, format: saved.variant });
          previewPanel.hidden = false;
          addNameHint.hidden = nameInput.value.trim() !== '';
          unlockCart();
          revealRestoredPreview();
          try { sessionStorage.setItem(storageKey, JSON.stringify(savedPreview)); } catch (err) { /* optional */ }
        };
        previewImage.onerror = function () { restoreError.hidden = false; };
        previewImage.src = savedPreview.image;
      } catch (err) { restoreError.hidden = false; }
    })();
  }

  if (sharedCard) {
    nameInput.value = shared.name;
    root.querySelectorAll('input[name="race-course-variant"]').forEach(function (input) {
      if (input.value === shared.format && !input.disabled) input.checked = true;
    });
    if (validTime(shared.time)) {
      var known = $('input[name="race-course-time-mode"][value="known"]');
      if (known) known.checked = true;
      timeInput.value = shared.time;
      syncTime();
    }
    clarityEvent('hint_opened');
    draw();
  }

  // Plan 77 F1: the first-screen button opens the edit under the example. Focus,
  // not just the anchor jump, so the keyboard is up for the name on a phone.
  var entry = testid('course-entry');
  if (entry) entry.addEventListener('click', function (event) {
    event.preventDefault();
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    nameInput.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
    nameInput.focus({ preventScroll: true });
    clarityEvent('race_picked');
  });
  nameInput.addEventListener('input', invalidate);
  timeInput.addEventListener('input', invalidate);
  modes.addEventListener('change', function () { invalidate(); syncTime(); });
  root.querySelectorAll('input[name="race-course-variant"]').forEach(function (input) {
    input.addEventListener('change', function () {
      if (hasPreview) draw(true);
      else invalidate();
    });
  });
  form.addEventListener('submit', function (event) { event.preventDefault(); draw(); });
  function addToCart() {
    if (!seal || cartBusy) return;
    clarityEvent('buy_clicked');
    cartBusy = true;
    syncDock();
    addButton.disabled = true;
    addButton.setAttribute('aria-busy', 'true');
    // Freeze the form during the cart request, so its visible choice cannot drift
    // from the sealed line that is already on its way to Shopify.
    frozenInputs = Array.prototype.filter.call(form.querySelectorAll('input, button'), function (node) { return !node.disabled; });
    frozenInputs.forEach(function (node) { node.disabled = true; });
    var properties = { _entitlement: seal.token, _course: seal.course };
    if (seal.mode === 'later') properties._time_pending = '1';
    var variantIds = Array.prototype.map.call(root.querySelectorAll('[data-variant-id]'), function (input) { return Number(input.getAttribute('data-variant-id')); });
    var items = [{ id: seal.id, quantity: 1, properties: properties }];
    var copyBox = testid('copy-addon');
    if (copyBox) {
      var copyId = Number(copyBox.getAttribute('data-copy-id'));
      variantIds.push(copyId);
      if (copyBox.checked) items.push({ id: copyId, quantity: 1, properties: { _entitlement: seal.token } });
    }
    window.TraceformBuy.replace(items, variantIds).then(function (added) {
      if (window.TraceformCartThumb) window.TraceformCartThumb.keep(added && added.items, window.TraceformCartThumb.capture(previewImage));
      return savingPreview.then(function () {
        try { history.replaceState(Object.assign({}, history.state, { traceformCoursePreview: true }), ''); } catch (err) { /* optional */ }
        window.location.href = root.getAttribute('data-checkout-url');
      });
    }).catch(function () {
      unlockCart();
      // The copy deck has no cart-error sentence. Keep the sealed print retryable.
    });
  }
  addButton.addEventListener('click', addToCart);
  dockButton.addEventListener('click', addToCart);
  if (testid('copy-addon')) testid('copy-addon').addEventListener('change', syncDock);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && history.state && history.state.traceformCoursePreview) {
      addButton.disabled = dockButton.disabled = true;
      window.location.reload();
    }
  });
  syncDock();
})();
